<script lang="ts">
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.js'
    import {myBalance} from 'src/components/cabinet/#services/myBalance'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import {currencyTransfer} from 'src/components/cabinet/#services/myTransactions'
    import {showAlert} from 'src/components/#common/alert/store'
    import {numberWithSpaces} from 'src/components/cabinet/#common/helpers'
    import toggleIcon from './toggle.svg'
    import arrowIcon from './arrow.svg'
    import walletIcon from 'src/components/cabinet/#common/transactions/icon-1.svg'
    import gameIcon from 'src/components/cabinet/#common/transactions/icon-2.svg'

    export let transferModalOpen
    //export let walletCurrency
    export let transferFrom
    export let transferTo
    let amount

    let transferSending = false
    let currencies = {
        LIS: 'Game balance',
        DRAG: 'Wallet balance',
        DOGE: 'Game balance',
        WDOGE: 'Wallet balance',
        PEPE: 'Game balance',
        WPEPE: 'Wallet balance',
        USDT: 'Game balance',
        WUSDT: 'Wallet balance'
    }

    let coins = {
        LIS: 'DRAG',
        DRAG: 'DRAG',
        DOGE: 'DOGE',
        WDOGE: 'DOGE',
        PEPE: 'PEPE',
        WPEPE: 'PEPE',
        USDT: 'USDT',
        WUSDT: 'USDT'
    }

    function transferToggle(currency) {
        if (currency) {
            transferFrom = currency
        } else {
            if (['DRAG'].includes(transferFrom)) {
                transferFrom = 'DRAG'
            } else if (['DOGE', 'WDOGE'].includes(transferFrom)) {
                transferFrom = transferFrom == 'DOGE' ? 'WDOGE' : 'DOGE'
            } else if (['PEPE', 'WPEPE'].includes(transferFrom)) {
                transferFrom = transferFrom == 'PEPE' ? 'WPEPE' : 'PEPE'
            } else if (['USDT', 'WUSDT'].includes(transferFrom)) {
                transferFrom = transferFrom == 'USDT' ? 'WUSDT' : 'USDT'
            }
        }
        if (['DRAG'].includes(transferFrom)) {
            transferTo = 'DRAG'
        }
        if (transferFrom == transferTo) {
            if (['DRAG'].includes(transferFrom)) {
                transferTo = 'DRAG'
            } else if (['DOGE', 'WDOGE'].includes(transferFrom)) {
                transferTo = transferFrom == 'DOGE' ? 'WDOGE' : 'DOGE'
            } else if (['PEPE', 'WPEPE'].includes(transferFrom)) {
                transferTo = transferFrom == 'PEPE' ? 'WPEPE' : 'PEPE'
            } else if (['USDT', 'WUSDT'].includes(transferFrom)) {
                transferTo = transferFrom == 'USDT' ? 'WUSDT' : 'USDT'
            }
        }
    }

    function getBalanceByCurrency(currency) {
        if (currency == 'LIS') {
            return roundNumber($myBalance.value.data.LIS + $myBalance.value.data.PLIS + $myBalance.value.data.BLIS)
        } else if (currency == 'DRAG') {
            return roundNumber($myBalance.value.data.DRAG + $myBalance.value.data.PWLIS)
        } else if (currency == 'DOGE') {
            return roundNumber($myBalance.value.data.DOGE + $myBalance.value.data.PDOGE)
        } else if (currency == 'WDOGE') {
            return roundNumber($myBalance.value.data.WDOGE + $myBalance.value.data.PWDOGE)
        } else if (currency == 'PEPE') {
            return roundNumber($myBalance.value.data.PEPE + $myBalance.value.data.PPEPE)
        } else if (currency == 'WPEPE') {
            return roundNumber($myBalance.value.data.WPEPE + $myBalance.value.data.PWPEPE)
        } else if (currency == 'USDT') {
            return roundNumber($myBalance.value.data.USDT + $myBalance.value.data.PUSDT)
        } else if (currency == 'WUSDT') {
            return roundNumber($myBalance.value.data.WUSDT + $myBalance.value.data.PWUSDT)
        }
    }

    function maxAmount() {
        if ($myBalance.hasValue) {
            if (transferFrom == 'DRAG') {
                amount = roundNumber($myBalance.value.data.DRAG + $myBalance.value.data.PWLIS)
            } else if (transferFrom == 'DOGE') {
                amount = roundNumber($myBalance.value.data.DOGE + $myBalance.value.data.PDOGE)
            } else if (transferFrom == 'WDOGE') {
                amount = roundNumber($myBalance.value.data.WDOGE + $myBalance.value.data.PWDOGE)
            } else if (transferFrom == 'PEPE') {
                amount = roundNumber($myBalance.value.data.PEPE + $myBalance.value.data.PPEPE)
            } else if (transferFrom == 'WPEPE') {
                amount = roundNumber($myBalance.value.data.WPEPE + $myBalance.value.data.PWPEPE)
            } else if (transferFrom == 'USDT') {
                amount = roundNumber($myBalance.value.data.USDT + $myBalance.value.data.PUSDT)
            } else if (transferFrom == 'WUSDT') {
                amount = roundNumber($myBalance.value.data.WUSDT + $myBalance.value.data.PWUSDT)
            }
        }
    }

    async function confirmTransfer() {
        transferSending = true
        try {
            await currencyTransfer.request({ data: {
                fromCurrency: transferFrom,
                toCurrency: transferTo,
                amount: amount.toString(),
                //walletCurrency
            }})

            amount = ''

            myBalance.send()

            showAlert.set({
                status: 'success',
                text: 'The currency was successfully transferred'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            transferSending = false
            transferModalOpen = false
        }
    }
</script>

<Modal bind:visible={transferModalOpen}>
    <svelte:fragment slot="content">
        <div class="modal-custom__title">Currency transfer</div>
        <div class="modal-custom__text">
            <div class="transfer-window">
                <div class="transfer-row">
                    <label class="notranslate">
                        <div class="wallet-icon">
                            {#if ['LIS', 'DOGE', 'PEPE', 'USDT'].includes(transferFrom)}
                                <img src="{gameIcon}" alt="">
                            {:else}
                                <img src="{walletIcon}" alt="">
                            {/if}
                        </div>
                        <div class="from-to">From</div>
                        <div class="wallet-name">
                            <span>{currencies[transferFrom]}:</span>
                            <span>
                                {!$myBalance.hasValue ? ".." : numberWithSpaces(getBalanceByCurrency(transferFrom))}
                                {coins[transferFrom]}
                            </span>
                        </div>
                    </label>
                </div>
                <div class="transfer-row d-flex justify-content-between">
                    <img src="{arrowIcon}" class="arrow" alt="">
                    {#if transferFrom !== 'DRAG'}
                        <button class="transfer-toggle" on:click={() => transferToggle(transferTo)}>
                            <img src="{toggleIcon}" alt="">
                        </button>
                    {/if}
                </div>
                <div class="transfer-row">
                    <label class="notranslate">
                        <div class="wallet-icon">
                            {#if ['LIS', 'DOGE', 'PEPE', 'USDT'].includes(transferTo)}
                                <img src="{gameIcon}" alt="">
                            {:else}
                                <img src="{walletIcon}" alt="">
                            {/if}
                        </div>
                        <div class="from-to">To</div>
                        <div class="wallet-name">
                            <span>{currencies[transferTo]}:</span>
                            <span>
                                {!$myBalance.hasValue ? ".." : numberWithSpaces(getBalanceByCurrency(transferTo))}
                                {coins[transferTo]}
                            </span>
                        </div>
                    </label>
                </div>
            </div>
            <label class="label">Amount</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="number" class="form-control" bind:value={amount} placeholder="Enter amount">
                    <span class="input-group-text empty-input-group-text notranslate">{coins[transferFrom]}</span>
                    <button class="btn btn-max-amount notranslate" on:click={maxAmount}><span>Max</span></button>
                </div>
            </div>
            {#if transferFrom === 'DRAG'}
                <div class="notice">
                    This action is irreversible. Once DRAG have been transferred into the game,
                    they will not be available for reverse transfer and withdrawal.
                </div>
            {/if}
        </div>
        <div class="modal-custom__footer">
            <button class="btn btn-cancel" on:click={() => { transferModalOpen = false }}>Close</button>
            <button class="btn btn-primary" class:loading={transferSending} on:click={() => confirmTransfer()}
                disabled={transferSending || !amount || amount < 0.0001}>
                <span>Confirm</span>
            </button>
        </div>
    </svelte:fragment>
</Modal>

<style>
    .transfer-window {
        background: #3b405e;
        border: 1px solid #CAD5E0;
        border-radius: 5px;
        padding: 15px;
        margin-bottom: 12px;
    }

    .notice {
        margin: 20px 0 -10px;
        font-size: 13px;
        background: rgba(244, 67, 54, 0.37);
        padding: 10px;
        border-radius: 6px;
    }

    .transfer-row + .transfer-row {
        margin-top: 10px;
    }

    .transfer-row span + span {
        padding-left: 4px;
    }

    .label {
        font-size: 14px;
        color: white;
        margin-bottom: 6px;
        font-weight: 300;
    }

    .arrow {
        margin-left: 6px;
        width: 14px;
    }

    .from-to {
        color: #8193a7;
        margin-right: 10px;
        min-width: 33px;
        height: 26px;
        display: flex;
        align-items: center;
    }

    .transfer-toggle {
        border: 0;
        background: none;
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: -10px 0;
    }

    .transfer-toggle img {
        width: 18px;
    }

    .transfer-row label {
        font-size: 14px;
        color: #d9e2eb;
        line-height: 1.4;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .btn-max-amount {
        font-size: 18px;
        line-height: 18px;
        color: #CAD5E0;
        box-shadow: none;
    }

    .wallet-icon {
        width: 26px;
        height: 26px;
        background: #61758A;
        border-radius: 30px;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
    }

    .wallet-icon img {
        width: 100%;
    }

    .form-control {
        border: 1px solid #CAD5E0;
        font-size: 20px;
        color: white;
        padding: 0 15px;
        border-right: 0;
        border-radius: 8px 0 0 8px;
    }

    .form-control:focus {
        box-shadow: none;
    }

    .input-group-text {
        color: #c8cbcd;
        background: #585F67;
        min-width: 70px;
        justify-content: center;
    }

    .empty-input-group-text {
        background: none;
        border-left: 0;
        border-right: 0;
        min-width: initial;
        padding: 0 20px;
        font-size: 18px;
        color: #61758A;
        font-weight: 500;
        transition: .25s;
    }

    .form-control:focus,
    .form-control:focus + span,
    .form-control:focus ~ button {
        border-color: #FF5D1C;
    }

    .btn-max-amount {
        background: none;
        color: white;
        border: 1px solid #CAD5E0;
        box-shadow: inset 0 0 0 1px #2e3549;
        border-left: 0;
        border-radius: 8px;
        min-width: 80px;
        height: 46px;
        font-size: 14px;
        font-weight: 400;
    }

    .btn-max-amount:before {
        content: "";
        background: #61758A;
        border-radius: 6px;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        left: 1px;
        top: 1px;
        transition: .25s;
    }

    .btn-max-amount:hover:before {
        background: #4e6174;
    }

    .btn-max-amount span {
        position: relative;
        z-index: 2;
    }

    .btn-max-amount:focus {
        box-shadow: none;
    }

    @media(max-width: 767px) {
        .wallet-name span {
            display: block;
        }

        .transfer-row span + span {
            padding-left: 0;
            color: #90aac5;
        }

        .form-control {
            font-size: 16px;
        }

        .transfer-row label {
            font-size: 13px;
        }

        .notice {
            margin: 15px 0 0;
        }
    }
</style>
